import React from 'react'
import { INegativeQuantityObject } from '@getgreenline/homi-shared'
import { Alert, Popover } from 'antd'

export interface Props {
  negativeInventoryList: INegativeQuantityObject[]
  onClick: (name: string) => void
}

export const NegativeInventoryAlert = React.memo((props: Props) => {
  const { negativeInventoryList } = props

  return (
    <>
      <Alert
        type='error'
        showIcon
        style={{ marginBottom: 10 }}
        message={
          <>
            {negativeInventoryList.length} product{negativeInventoryList.length > 1 ? 's' : ''} with
            negative inventory
            <Popover
              trigger='click'
              placement='bottom'
              content={
                <div style={{ maxWidth: 450, maxHeight: 600, overflowY: 'scroll' }}>
                  <table
                    className='table table-sm'
                    style={{ maxWidth: 450, maxHeight: 600, overflowY: 'scroll' }}
                  >
                    <thead className='thead-light'>
                      <tr>
                        <th>Product</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {negativeInventoryList.map((product: INegativeQuantityObject, index) => {
                        return (
                          <tr key={product.sku + product.name + index}>
                            <td>
                              <div>
                                <small>SKU: {product.sku}</small>
                              </div>
                              <a
                                onClick={(e) => {
                                  props.onClick(product.name)
                                }}
                              >
                                {product.name}
                              </a>
                            </td>
                            <td className='text-right'>
                              <b className='text-danger'>{product.quantity}</b>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  <Alert type='warning' showIcon message='Audits are recommended.' />
                </div>
              }
            >
              <a className='ml-4'>See more</a>
            </Popover>
          </>
        }
      />
    </>
  )
})
